import React, { FC } from 'react'
import styles from './Cart.module.scss'
import CartIcon from 'svg/bag.svg'
import SALink from 'components/SALink'
import { resetNotification } from 'components/CartUrgencyBar/helper'
import { getPageParamsSection } from 'selectors/page'
import { getCartItemsCount } from 'apps/private/checkout/selectors'
import { useSelector } from 'react-redux'
import { getCartCount } from 'selectors/user/cart'

const Cart: FC = () => {
  const pageParamsSection = useSelector(getPageParamsSection)
  const cartItemCount = useSelector(getCartItemsCount)
  const cartCount = useSelector(getCartCount)
  const isNavVisibleOnCartPage = pageParamsSection === 'cart'

  return (
    <SALink
      aria-label='View your cart'
      data-type='cart-icon'
      data-gtm-event='top-nav'
      href='/cart'
      rel='nofollow'
      title='View Cart'
      onClick={resetNotification}
    >
      <div className={styles.cart}>
        <CartIcon className={styles.cartIcon} />
        <span className={styles.cartCount} data-type='cart-count'>
          {isNavVisibleOnCartPage ? cartItemCount : cartCount || 0}
        </span>
      </div>
    </SALink>
  )
}

export default Cart
